<template>
  <vs-popup class=" user-edit-popup"
            id="popup"
            title="STAFF UPDATE"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickUpdateStaffUser)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">First Name</small>
                <vs-input v-model="selectedStaff.name"  name="name" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="email" name="email" rules="required|email" v-slot="{ errors }">
                <small class="label">Email</small>
                <!-- <vs-input disabled  v-model="selectedStaff.email" class="w-full"  name="email" type="email" label="" /> -->
                <span class="text-danger text-sm">{{ errors[0] }}</span>
                <vx-input-group>
                  <vs-input v-model="selectedStaff.email" name="formulation_code" class="w-full" label=""
                            readonly
                            :danger="!!errors[0]"
                            :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  <template slot="prepend" >
                    <div style="cursor: pointer" @click="onClickUpdateEmail()" class="prepend-text btn-addon">
                      <vs-button v-if="$can('edit-staff-email')" style="border-radius: 0" icon-pack="feather" icon="icon-edit" type="border"
                                 color="primary" tooltip="Update Email"></vs-button>
                    </div>
                  </template>
                </vx-input-group>
                <div v-if="emailChangeInfo" class="mt-2 p-3 rounded" style="background-color: #e8f4fd; border: 1px solid #b3d9f7; color: #1a6fa8; font-size: 0.82rem; display: flex; align-items: flex-start; gap: 8px;">
                  <span class="feather-icon" style="flex-shrink:0; margin-top:1px;"><i data-feather="info"></i></span>
                  <span>{{ emailChangeInfo }}</span>
                </div>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <small class="label">Address</small>
              <vs-textarea v-model="selectedStaff.address_1" height="100px"/>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="contact_1" name="contact_1" rules="contactNumber|min_tel|max_tel" v-slot="{ errors }">
                <small class="label">Mobile</small>
                <vs-input v-model="selectedStaff.contact_1" class="w-full"  name="contact_1" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="user_group" name="user_group" rules="required" v-slot="{ errors }">
                <small class="label">User Group</small>
                <v-select name="user_group" :reduce="option => option.id" :closeOnSelect="true" v-model="selectedStaff.role_id"  :options="roles" label="name" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-8">
            <div class="vx-col md:w-1/2 md:mb-0">
              <small class="label">Is this user an account manager/handler?</small>
              <vs-switch v-model="selectedStaff.is_account_handler" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </div>
            <div class="vx-col md:w-1/2 md:mb-0">
              <small class="label">Is this user an approving manager for annual leave?</small>
              <vs-switch v-model="selectedStaff.is_leave_reviewer" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </div>
          </div>
          <div class="vx-row mb-8">
            <div class="vx-col md:w-1/2 md:mb-0">
              <small class="label">Exclude from leave tracking?</small>
              <vs-switch  :value="!selectedStaff.is_leave_enabled" @input="v => selectedStaff.is_leave_enabled = !v" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </div>
            <div class="vx-col md:w-1/2 md:mb-0">
              <ValidationProvider vid="date_of_birth" name="date_of_birth" rules="" v-slot="{ errors }">
                <small class="label">Date of Birth</small>
                <flat-pickr v-model="selectedStaff.date_of_birth" :config="{ dateFormat: 'd/m'}" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="dep" name="dep" rules="required" v-slot="{ errors }">
                <small class="label">Departments</small>
                <v-select name="dep" multiple label="name" :closeOnSelect="false" 
                v-model="selectedStaff.department_ids" 
                :options="departments" :dir="$vs.rtl ? 'rtl' : 'ltr'" :reduce="option => option.id"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
              <div class="vx-row mt-4">
                <vs-button v-if="selectedStaff.department_ids.length !== departments.length" @click.stop="onClickSelectAll" size="small" class="ml-4">Select all</vs-button>
                <vs-button v-if="selectedStaff.department_ids.length > 0" @click.stop="onClickRemoveAllDeps" color="danger" size="small" class="ml-4">Clear all</vs-button>
              </div>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="reports" name="reports" rules="" v-slot="{ errors }">
                <small class="label">Reports</small>
                <v-select multiple label="name" :closeOnSelect="false" :reduce="option => option.id"
                          v-model="selectedStaff.reports" :clearable="false" :options="reports" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
              <div class="vx-row mt-4">
                <vs-button v-if="selectedStaff.reports.length !== reports.length" @click.stop="onClickSelectAllReport" size="small" class="ml-4">Select all</vs-button>
                <vs-button v-if="selectedStaff.reports.length > 0" @click.stop="onClickRemoveAllReports" color="danger" size="small" class="ml-4">Clear all</vs-button>
              </div>
            </div>
          </div>

          <hr class="my-8">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="raw_material_order_threshold" name="raw_material_order_threshold" rules="" v-slot="{ errors }">
                <small class="label">RM Order Threshold</small>
                <vs-input v-model="selectedStaff.raw_material_order_threshold" class="w-full"  name="contact_1" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="sundry_order_threshold" name="sundry_order_threshold" rules="" v-slot="{ errors }">
                <small class="label">Sundry Order Threshold</small>
                <vs-input v-model="selectedStaff.sundry_order_threshold" class="w-full"  name="contact_1" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="other_item_order_threshold" name="other_item_order_threshold" rules="" v-slot="{ errors }">
                <small class="label">Other Item Order Threshold</small>
                <vs-input v-model="selectedStaff.other_item_order_threshold" class="w-full"  name="contact_1" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-8">
            <div class="vx-col md:w-full md:mb-0">
              <small class="label">Enable 2FA?</small>
              <vs-switch @input="onChange2FA()" v-model="selectedStaff.is_google_2fa_enable" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
      <ManageMyQualification class="mt-3" :staff_id="id + ''" :action_buttons="false" v-if="open"/>
      <ManageMySkiil class="mt-3" :staff_id="id + ''" :action_buttons="false" v-if="open"/>
    </vx-card>
    <two-f-a-pop-up v-on:refreshData="refreshData()" ref="twoFAPopUp"/>
    <vs-prompt
      @cancel="onClick2FADisableCancel"
      @accept="onClick2FADisable"
      @close="onClick2FADisableCancel"
      title="Confirm"
      accept-text="Disable"
      color="danger"
      :active.sync="active2FADisabledPrompt">
      <div class="con-exemple-prompt">
        <span>Enter your password</span>
        <vs-input type="password" v-model="password" class="mt-3 w-full" />
      </div>
    </vs-prompt>
    <vs-prompt
      @cancel="onCancelUpdateEmail"
      @accept="onConfirmUpdateEmail"
      @close="onCancelUpdateEmail"
      title="Update Email Address"
      accept-text="Update"
      color="primary"
      :active.sync="activeUpdateEmailPrompt">
      <div class="con-exemple-prompt">
        <span>Enter the new email address</span>
        <vs-input type="email" v-model="newEmail" placeholder="New email address" class="mt-3 w-full" />
      </div>
    </vs-prompt>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const StaffRepository = RepositoryFactory.get('staff')
  const DepartmentsRepository = RepositoryFactory.get('departments')
  const RolesRepository = RepositoryFactory.get('roles');
  const ReportingRepository = RepositoryFactory.get('reporting');
  import vSelect from 'vue-select'
  import SuccessMessage from "@/mixins/SuccessMessage";
  import ErrorMessages from "@/mixins/ErrorMessages";
  import flatPickr from "vue-flatpickr-component";
  import 'flatpickr/dist/flatpickr.css'

  import TwoFAPopUp from "@/components/popups/user-settings/TwoFAPopUp";
  import ManageMyQualification from '@/views/pages/user-settings/training-qualifications/ManageMyQualification.vue'
  import ManageMySkiil from '@/views/pages/user-settings/training-qualifications/ManageMySkiil.vue'

  function initialState() {
    return {
      open: false,
      id: '',
      roles: [],
      reports: [],
      role: {},
      selectedStaff: {
        department_ids: [],
        reports: []
      },
      departments: [],
      active2FADisabledPrompt: false,
      password: '',
      activeUpdateEmailPrompt: false,
      newEmail: '',
      emailChangeInfo: '',
    }
  }

export default {
  name: 'UpdateStaffPopUp',
  data () {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.id = id
        await this.loadDepartments();
        await this.loadRoles();
        await this.loadReports();
        await this.getStaff();
        this.open = true;
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    async refreshData() {
      await this.getStaff()
      await this.$parent.refreshData()
    },
    async onClickUpdateStaffUser() {
      const vue = this;
      this.$vs.loading()
     try {
       this.selectedStaff.raw_material_order_threshold = Number(this.selectedStaff.raw_material_order_threshold).toFixed(2)
       this.selectedStaff.sundry_order_threshold = Number(this.selectedStaff.sundry_order_threshold).toFixed(2)
       this.selectedStaff.other_item_order_threshold = Number(this.selectedStaff.other_item_order_threshold).toFixed(2)
       await StaffRepository.updateStaff(this.selectedStaff.id, this.selectedStaff)
       this.showSuccessMessage('Staff update successfully')
       await vue.$parent.refreshData()
       this.open = false;
     } catch (e) {
       this.convertAndNotifyError(e)
     }
      this.$vs.loading.close()
    },
    async onChange2FA() {
      if(this.selectedStaff.is_google_2fa_enable) {
        await this.$refs.twoFAPopUp.openPopup(this.id)
      } else {
        this.open = false
        this.active2FADisabledPrompt = true
      }
    },
    onClick2FADisableCancel() {
      this.password = ''
      this.active2FADisabledPrompt = false
      this.open = true
      this.selectedStaff.is_google_2fa_enable = !this.selectedStaff.is_google_2fa_enable
    },
    async onClick2FADisable() {
      this.$vs.loading()
      try {
        await StaffRepository.disable2FA({ password: this.password }, this.id)
        this.showSuccessMessage('2FA disabled successfully')
        await this.refreshData()
      } catch (e) {
        await this.refreshData()
        this.convertAndNotifyError(e)
      }
      this.password = ''
      this.$vs.loading.close()
      this.open = true
    },
    async loadReports() {
      this.$vs.loading();
      const {data} = await ReportingRepository.getListOfChartManage()
      this.reports =  data.data
      this.$vs.loading.close()
    },
    async loadDepartments() {
      this.$vs.loading();
      const {data} = await DepartmentsRepository.get(' ', '', '', '' )
      this.departments =  data.data
      this.$vs.loading.close()
    },
    async loadRoles() {
      this.roles = [];
      this.$vs.loading();
      const {data} = await RolesRepository.getListNoPagination()
      this.roles =  data.data
      this.$vs.loading.close()
    },
    async getStaff() {
      this.$vs.loading();
      try {
        const { data } = await StaffRepository.getStaff(this.id)
        this.selectedStaff = data.data
        this.selectedStaff.role_id = data.data.role.id
        this.selectedStaff.reports = data.data.report.map((x) => x.id)
        this.selectedStaff.department_ids = this.selectedStaff.departments.map((x) => x.id)
      } catch (error) {
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    async onClickReset() {
      await this.getStaff();
      await this.loadDepartments();
      await this.loadRoles();
    },
    onClickSelectAll() {
      this.selectedStaff.department_ids.splice(0, this.selectedStaff.department_ids.length)
      this.departments.map((dep) => {
          this.selectedStaff.department_ids.push(dep.id)
      })  
    },
    onClickRemoveAllDeps() {
      this.selectedStaff.department_ids.splice(0, this.selectedStaff.department_ids.length)
    },
    async onClickSelectAllReport() {
      this.selectedStaff.reports.splice(0, this.selectedStaff.reports.length)
      this.reports.map((rep) => {
          this.selectedStaff.reports.push(rep.id)
      })  
    },
    onClickRemoveAllReports() {
      this.selectedStaff.reports.splice(0, this.selectedStaff.reports.length)
    },
    onClickUpdateEmail() {
      this.newEmail = ''
      this.open = false
      this.activeUpdateEmailPrompt = true
    },
    onCancelUpdateEmail() {
      this.newEmail = ''
      this.activeUpdateEmailPrompt = false
      this.open = true
    },
    async onConfirmUpdateEmail() {
      this.$vs.loading()
      try {
        await StaffRepository.updateEmail(this.id, { email: this.newEmail })
        this.emailChangeInfo = 'A confirmation link has been sent to ' + this.newEmail + '. The email address will be updated once the link is confirmed.'
        await this.getStaff()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.newEmail = ''
      this.$vs.loading.close()
      this.open = true
    },
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
    TwoFAPopUp,
    flatPickr,
    ManageMyQualification,
    ManageMySkiil
  },
  watch: {
    selectedStaff: {
      deep: true,
      handler(newval, oldval) {
        this.selectedStaff = newval
      }
    }
  }
}
</script>

<style scoped>
  .video-wrapper {
    width: 100%;
    height: 100%;
  }

  .video-wrapper video {
    object-fit: cover;
    width: 100%;
    height: 100%;

  }
  .image-wrapper {
    width: 100%;
    height: 75%;
  }


</style>
